import httpRequestsPaths from "@helpers/httpRequestsPaths/httpRequestsPaths";
import endpointsPaths from "../endpointsPaths/endpointsPaths";
import httpRequest from "../httpRequest";
export const getAsesoresLectura = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getAsesoresLectura}`,
        method: "GET",
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const validarAsesorLogeado = async (correo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.validarAsesor}`,
        method: "POST",
        body: JSON.stringify({correo})
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};




export const getUsuariosByFolio = async (folioContrato) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getUsuariosByFolio}/${folioContrato}`,
        method: "GET",
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const getUsuariosUvegRegistrados = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.obtenerUsuariosUveg}`,
        method: "POST",
      });

      resolve(grupos);
    } catch (error) {
      console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};



export const actualizarContadorGrupo = async (folioContrato, idGrupo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.descontarEstudianteGrupo}/${idGrupo}`,
        method: "POST",
        body: JSON.stringify({folioContrato})
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const obtenerEstadisticasEstudiante = async (correo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.obtenerEstadisticas}`,
        method: "POST",
        body: JSON.stringify(correo)
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const getPromedioGeneral = async (folioGrupo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getPromedioGeneral}/${folioGrupo}`,
        method: "POST",
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};